export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const PASSWORD_FORGET = '/pw-forget';
export const HOME = '/play';
export const ACCOUNT = '/account';
export const EDIT = '/edit';
export const KNOWLEDGE_DASHBOARD = '/measure';
export const VIEW = '/view';
export const SETTINGS = '/settings';



// WEBPACK FOOTER //
// ./src/constants/routes.tsx